/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Standings_Rtp_OptInputs */



/**
* | output |
* | --- |
* | "Rating Points (RTP)" |
*
* @param {League_Standings_Rtp_OptInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_standings_rtp_opt = /** @type {((inputs?: League_Standings_Rtp_OptInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Standings_Rtp_OptInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Points de Rating (RTP)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Puntos de Rating (RTP)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pontos de Rating (RTP)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Punti Rating (RTP)")
	return /** @type {LocalizedString} */ ("Rating Points (RTP)")
});